import {
  Component,
  ElementRef,
  Inject,
  Injector,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import {
  AbstractControl,
  UntypedFormControl,
  UntypedFormGroup,
  ValidationErrors,
  Validators,
} from "@angular/forms";
import { FormService } from "@services/form/form.service";
import { UsersService } from "@services/entity/users.service";
import { CustomersService } from "@services/entity/customers.service";
import { StripeInfosService } from "@services/entity/stripe-infos.service";
import { UserProfile } from "@dto/userProfile";
import { DashboardProfile } from "@dto/dashboardProfile";
import { FilesService } from "@services/files/files.service";
import Swal from "sweetalert2";
import { UploadResponse } from "@dto/uploadResponse";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ChangePasswordDialogForCustomerContentComponent } from "@components/dialog/change-password-for-customer-dialog-content/change-password-for-customer-dialog-content.component";
import { ChangePasswordDialogContentComponent } from "@components/dialog/change-password-dialog-content/change-password-dialog-content.component";
import { DeleteUserProfileDialogContentComponent } from "@components/dialog/delete-user-profile-dialog-content/delete-user-profile-dialog-content.component";
import { MessageService } from "@services/message/message.service";
import { ActivatedRoute, Router } from "@angular/router";
import "@angular/localize/init";
import { DeleteUserForCustomerDialogContentComponent } from "../../dialog/delete-user-for-customer-dialog-content/delete-user-for-customer-dialog-content.component";
import { ComponentBase } from "@abstracts/component-base";
import { PatchUserProfilePicture } from "@dto/httpPatch/userProfile";
import { DomSanitizer } from "@angular/platform-browser";
import { ToastService } from "@services/toast/toast.service";
import { CancelSubscriptionDialogContentComponent } from "@components/dialog/cancel-subscription-dialog-content/cancel-subscription-dialog-content.component";
import { PaymentsService } from "@services/payments/payments.service";
import { DashboardService } from "../../../services/dashboard/dashboard.service";
import { NgxSpinnerService } from "ngx-spinner";
import { StripeInfoDto } from "@dto/stripeInfoDto";
import { CheckoutDto } from "@dto/checkoutDto";
import { PricingDto } from "@dto/pricingDto";
import { PricingsService } from "@services/entity/pricings.service";
import { plainToClass } from "class-transformer";
import { UserDto } from "@dto/userDto";
import { InvoiceDto } from "@dto/invoiceDto";
import { TransactionDto } from "@dto/transactionDto";
import { TransactionsService } from "@services/entity/transactions.service";
import { ImageCroppedEvent, base64ToFile } from "ngx-image-cropper";
import { InviteCustomerDialogContentComponent } from "@components/dialog/invite-customer-dialog/invite-customer-dialog-content/invite-customer-dialog-content.component";
import { SubscriptionDetailDto } from "@dto/subscriptionDetailDto";
import { User } from "@models/identity/user";
import { SendInviteRequest } from "@dto/sendInviteRequest";
import { EditEmailDialogContentComponent } from "../../dialog/edit-email-dialog/edit-email-dialog-content/edit-email-dialog-content.component";
import { EnterConfirmationCodeDialogContentComponent } from "../../dialog/enter-confirmation-code-dialog/enter-confirmation-code-dialog-content/enter-confirmation-code-dialog-content.component";
import { Console, error } from "console";
import { finalize } from "rxjs/operators";
import { waitForAsync } from "@angular/core/testing";
import { Location } from "@angular/common";
import { ConfirmationCodeDto } from "../../../dto/confirmationCodeDto";
import { EmspRequestDto } from "@dto/emspRequestDto";
import { request } from "http";
import { UpdateUserEmailRequest } from "../../../dto/updateUserEmailRequest";
import parse from "date-fns/parse/index.js";

@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.scss"],
})
export class ProfileComponent extends ComponentBase implements OnInit {
  public className = "ProfileComponent";

  public userProfile: UserProfile;
  public currentUser: UserDto = new UserDto();
  public dashboardProfile: DashboardProfile;
  public permissionProfile: any;
  public picture: any;
  public successMessage = $localize`:@@ProfileSuccssesMessage:Profil erfolgreich aktualisiert.`;
  public isUserView: boolean;
  public isOperatorView: boolean;
  public isCustomerView: boolean;
  public isSupporter: boolean = false;
  public isUserProfile: boolean;
  public formCreated: boolean;
  public pricing?: PricingDto;
  public stripeInfo?: StripeInfoDto;
  public customerStripeInfo: StripeInfoDto = new StripeInfoDto();
  public hasStripeAccount?: boolean;
  public invoices?: InvoiceDto[] = [];
  public url: string;
  public customDelivery: string;
  public isCustomDelivery: boolean;
  public transactions: TransactionDto[];
  public isCropping: boolean;
  public isLoading: boolean;
  public subscriptionDetails: SubscriptionDetailDto;
  public loadingSubscriptionDetails: boolean;
  public isRedirectedFromPaypal: boolean = false;
  isBtnSaveDisabled: boolean = false;
  public display: string = "none";
  public applicationFee: any;
  public ncompany: string;
  public ncity: string;
  public nnumber: string;
  public nstreet: string;
  public npostalcode: string;
  public npercent: string;
  public emspForm: UntypedFormGroup = new UntypedFormGroup({});

  private file: File;
  private userId: string;
  public isEmsp: boolean;

  @ViewChild("operatorView") operatorView: TemplateRef<any>;
  @ViewChild("customerView") customerView: TemplateRef<any>;
  @ViewChild("userView") userView: TemplateRef<any>;
  public templateView: TemplateRef<any>;

  imageChangedEvent: any = "";
  croppedImage: any = "";
  File: any;

  constructor(
    @Inject("BASE_URL") private baseUrl: string,
    public dialog: NgbModal,
    private location: Location,
    public formService: FormService,
    public messageService: MessageService,
    private transactionsService: TransactionsService,
    private usersService: UsersService,
    private pricingsService: PricingsService,
    private stripeInfosService: StripeInfosService,
    private dashboardService: DashboardService,
    private customerService: CustomersService,
    private filesService: FilesService,
    private paymentsService: PaymentsService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer,
    private toastService: ToastService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    public injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.loadingSubscriptionDetails = true;
    this.createEmspForm();

    this.isUserProfile = this.activatedRoute.snapshot.data["isUserProfile"];
    this.componentSettings.footerVisible = false;

    this.isOperatorView = this.authenticationService.userHasRole("Operator");
    this.isCustomerView = this.authenticationService.userHasRole("Customer");
    this.isUserView = this.authenticationService.userHasRole("User");

    this.isSupporter = this.authenticationService.userHasRole("Supporter");

    this.authenticationService.getLoggedInUserSubject().subscribe((user) => {
      this.currentUser = user;
      if (this.currentUser) this.getStripeInfoOfUser();
    });

    window.setTimeout(() => {
      this.loadPricing();
    }, 2000);
  }

  ngAfterViewInit() {
    this.templateView = this.determineTemplate();
    this.currentUser = this.authenticationService.getLoggedInUser();
    if (this.currentUser) this.getStripeInfoOfUser();
    this.loadProfile();
    this.loadDashboardProfile();
    super.ngOnInit();
    this.loadPricing();
    this.handleStripeRedirect();
  }

  handleStripeRedirect() {
    const urlParams = new URLSearchParams(window.location.search);
    const setupIntentId = urlParams.get("setup_intent");
    const redirectStatus = urlParams.get("redirect_status");

    if (setupIntentId && redirectStatus === "succeeded") {
      this.paymentsService
        .createChargingParkSubscriptionByPaypal(setupIntentId)
        .subscribe(
          (result) => {
            this.isRedirectedFromPaypal = true;
          },
          (error) => {
            console.error(
              "Error creating charging park subscription by paypal:",
              error
            );
          }
        );
    }
  }

  getStripeInfoOfUser() {
    var customerId = this.activatedRoute.parent.snapshot.params.key;
    if (customerId != null) {
      //for operator customer view, stripeinfo not used at the moment
      //   this.stripeInfosService.getStripeInfoOfCustomer(customerId).subscribe(result => {
      //     this.stripeInfo = result;
      //     this.hasStripeAccount = this.stripeInfo.stripeAccountId != null
      //   })
    } else {
      if (this.isOperatorView) {
        //for Operator user view, stripeinfo not used at the moment
        //     if (this.isUserProfile) {
        //       this.userId = this.activatedRoute.parent.snapshot.params.id;
        //       this.stripeInfosService.getStripeInfoOfUser(this.userId).subscribe(stripeInfo => {
        //         this.stripeInfo = stripeInfo
        //         this.hasStripeAccount = this.stripeInfo.stripeAccountId != null
        //       })
        //     }
      } else {
        //For User
        this.stripeInfosService
          .getStripeInfoOfUser(this.currentUser.id)
          .subscribe((stripeInfo) => {
            this.stripeInfo = stripeInfo;
            this.hasStripeAccount = this.stripeInfo.stripeAccountId != null;
          });
      }
    }
  }

  getEmsp() {
    if (this.isOperatorView) {
      this.isEmsp = this.userProfile.isEmsp;
      if (this.isEmsp) {
        this.customerService
          .getApplicationFeeForEmsp(
            this.activatedRoute.parent.snapshot.params.key,
            this.userProfile.id
          )
          .subscribe((res) => {
            this.applicationFee = res;
            this.applyEmspResponseToView(res);
          });
      }
    }
  }

  enableEmspDialog() {
    this.resetEmspForm();
    this.display = "block";
  }

  onCloseHandled() {
    this.resetEmspForm();
    this.display = "none";
  }

  loadDashboardProfile() {
    if (this.isOperatorView) {
      var customerId = this.activatedRoute.parent.snapshot.params.key;
      if (customerId != null)
        this.dashboardService
          .getDashboardProfileOfCustomer(customerId)
          .subscribe((result) => {
            this.dashboardProfile = result;
          });
    } else {
      this.dashboardService.getDashboardProfile().subscribe((result) => {
        this.dashboardProfile = result;
      });
    }
  }

  getUsage() {
    if (this.isOperatorView) {
      var customerId = this.activatedRoute.parent.snapshot.params.key;
      // this.customerService.getCustomerPermissions(customerId).subscribe(permissions => {
      //   permissions.forEach(permissionObject => {
      //     this.permissions[permissionObject.permission.name] = permissionObject.value;
      //   })
      // });
      if (customerId != null)
        this.customerService
          .getSubscriptionDetailsOfCustomer(customerId)
          .subscribe((subscriptionDetails) => {
            this.subscriptionDetails = subscriptionDetails;
            this.loadingSubscriptionDetails = false;
          });
    } else {
      if (this.currentUser) {
        // this.permissionsService.getPermissionsOfCurrentCustomer().then(permissions => {
        //   permissions.forEach(permissionObject => {
        //     this.permissions[permissionObject.permission.name] = permissionObject.value;
        //   })
        // });
        this.usersService
          .getCustomerSubscriptionDetailsOfCurrentCustomer()
          .subscribe((subscriptionDetails) => {
            this.subscriptionDetails = subscriptionDetails;
            this.loadingSubscriptionDetails = false;
          });
      }
    }
  }

  loadProfile() {
    if (this.isOperatorView) {
      if (this.isUserProfile) {
        this.userId = this.activatedRoute.parent.snapshot.params.id;
        this.usersService.getUserProfileById(this.userId).subscribe(
          (result) => {
            this.userProfile = result;
            this.resetEmspForm();
            this.userProfile["typeDisplay"] = this.mapType();
            this.userProfile["subscriptionTypeIdDisplay"] =
              this.mapSubscriptionType();
            this.loadProfilePicture();
            this.getUsage();
            this.createForm();
          },
          (error) => {}
        );
      } else {
        var customerId = this.activatedRoute.parent.snapshot.params.key;
        this.usersService.getUserProfileOfCustomer(customerId).subscribe(
          (result) => {
            this.userId = result.id;
            this.userProfile = result;
            this.resetEmspForm();
            this.userProfile["typeDisplay"] = this.mapType();
            this.userProfile["subscriptionTypeIdDisplay"] =
              this.mapSubscriptionType();
            this.loadProfilePicture();
            this.getUsage();
            this.createForm();
            this.getEmsp();
          },
          (error) => {}
        );
      }
    } else {
      this.usersService.getUserProfile().subscribe(
        (result) => {
          this.userId = result.id;
          this.userProfile = result;
          this.resetEmspForm();
          this.userProfile["typeDisplay"] = this.mapType();
          this.userProfile["subscriptionTypeIdDisplay"] =
            this.mapSubscriptionType();
          this.loadProfilePicture();
          this.getUsage();
          this.createForm();
        },
        (error) => {}
      );
    }
  }

  loadProfilePicture() {
    if (this.userProfile.pictureFileName) {
      this.filesService.getPicture(this.userProfile.pictureFileName).subscribe(
        (result) => {
          var unsafeImageUrl = URL.createObjectURL(result);
          this.picture = this.sanitizer.bypassSecurityTrustUrl(unsafeImageUrl);
        },
        (error) => {
          console.error(error);
        }
      );
    } else {
      this.filesService
        .getPicture("pictures/profile/placeholder_profile.jpg")
        .subscribe(
          (result) => {
            var unsafeImageUrl = URL.createObjectURL(result);
            this.picture =
              this.sanitizer.bypassSecurityTrustUrl(unsafeImageUrl);
          },
          (error) => {
            console.error(error);
          }
        );
    }
  }

  determineTemplate() {
    if (this.authenticationService.userHasRole("Operator")) {
      return this.operatorView;
    } else if (this.authenticationService.userHasRole("Customer")) {
      return this.customerView;
    } else if (this.authenticationService.userHasRole("User")) {
      return this.userView;
    }
  }

  createForm() {
    if (this.authenticationService.userHasRole("Operator")) {
      this.createFormForCustomer();
    } else if (this.authenticationService.userHasRole("Customer")) {
      this.createFormForCustomer();
    } else if (this.authenticationService.userHasRole("User")) {
      this.createFormForUser();
    }

    if (this.isSupporter) this.formService.form.disable();
    this.formCreated = true;
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.isCropping = true;
  }

  async imageCropped(event: ImageCroppedEvent) {
    this.picture = event.base64;
    let file = base64ToFile(this.picture);
    var blob = file;
    var newFile = new File([blob], this.userId + "." + "png", {
      type: "image/ png",
    });

    var uploadResult = await this.uploadFile(newFile);

    const patch: PatchUserProfilePicture = {
      pictureUri: uploadResult[0].fileUri,
      pictureFileName: uploadResult[0].fileName,
    };

    if (this.isOperatorView) {
      if (this.isUserProfile) {
        this.usersService
          .patchProfilePictureOfUser(patch, this.userId)
          .subscribe((result) => {
            this.loadProfile();
          });
      } else {
        var customerId = this.activatedRoute.parent.snapshot.params.key;

        this.usersService
          .patchProfilePictureOfCustomer(patch, customerId)
          .subscribe((result) => {
            this.loadProfile();
          });
      }
    } else {
      this.usersService.patchProfilePicture(patch).subscribe((result) => {
        this.loadProfile();
      });
    }
  }

  imageLoaded() {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }

  showEmspDialog() {
    Swal.fire({
      title: $localize`:@@ChangeSitePartnerHeader:Möchten Sie das Betreibermodell für diesen Kunden anwenden?`,
      icon: "warning",
      showConfirmButton: true,
      showDenyButton: true,
      denyButtonText: $localize`:@@ProfileWrongTypeConfirm:Zurück`,
      focusDeny: false,
      confirmButtonText: $localize`:@@DialogOkButton:OK`,
      confirmButtonColor: "green",
    }).then((result) => {
      if (result.isConfirmed) {
        this.resetEmspForm();
        this.display = "block";
      }
    });
  }

  removeEmspDialog() {
    Swal.fire({
      title: $localize`:@@ChangeSitePartnerHeader:Möchten Sie das Betreibermodell wirklich auflösen?`,
      icon: "warning",
      showConfirmButton: true,
      showDenyButton: true,
      denyButtonText: $localize`:@@ProfileWrongTypeConfirm:Zurück`,
      focusDeny: false,
      confirmButtonText: $localize`:@@DialogOkButton:OK`,
      confirmButtonColor: "green",
    }).then((result) => {
      if (result.isConfirmed) {
        this.disableEmsp();
      }
    });
  }

  enableEmsp() {
    if (this.emspForm.invalid) {
      this.emspForm.markAllAsTouched();
      return;
    }

    const emspPercent = this.parseEmspPercent(
      this.emspForm.get("sitepartnerPercent").value
    );
    if (emspPercent == null) {
      this.emspForm.get("sitepartnerPercent").setErrors({ invalidPercent: true });
      this.emspForm.get("sitepartnerPercent").markAsTouched();
      return;
    }

    const emspAddress = this.emspForm.get("address") as UntypedFormGroup;
    var newEmsp: EmspRequestDto = {
      masterUserEmail: this.userProfile.email,
      company: this.emspForm.get("company").value?.trim(),
      percent: emspPercent,
      address: {
        id: 0,
        city: emspAddress.get("city").value?.trim(),
        houseNumber: emspAddress.get("houseNumber").value?.trim(),
        postalCode: emspAddress.get("postalCode").value?.trim(),
        street: emspAddress.get("street").value?.trim(),
      },
    };
    this.customerService
      .enableEmsp(this.activatedRoute.parent.snapshot.params.key, newEmsp)
      .subscribe((result) => {
        this.isEmsp = result;
        this.ncompany = newEmsp.company;
        this.display = "none";
        this.customerService
          .getApplicationFeeForEmsp(
            this.activatedRoute.parent.snapshot.params.key,
            this.userProfile.id
          )
          .subscribe((res) => {
            this.applicationFee = res;
            this.applyEmspResponseToView(res);
            this.resetEmspForm();
          });
      });
  }

  disableEmsp() {
    var newEmsp: EmspRequestDto = {
      masterUserEmail: this.userProfile.email,
    };
    this.customerService
      .disableEmsp(this.activatedRoute.parent.snapshot.params.key, newEmsp)
      .subscribe((result) => {
        this.isEmsp = result;
        this.display = "none";
        this.ncompany = null;
        this.customerService
          .getApplicationFeeForEmsp(
            this.activatedRoute.parent.snapshot.params.key,
            this.userProfile.id
          )
          .subscribe((res) => {
            this.applicationFee = res;
          });
      });
  }

  private createEmspForm() {
    this.emspForm = new UntypedFormGroup({
      company: new UntypedFormControl("", [Validators.required]),
      address: new UntypedFormGroup({
        street: new UntypedFormControl("", [Validators.required]),
        houseNumber: new UntypedFormControl("", [Validators.required]),
        postalCode: new UntypedFormControl("", [Validators.required]),
        city: new UntypedFormControl("", [Validators.required]),
      }),
      sitepartnerPercent: new UntypedFormControl("", [
        Validators.required,
        this.validateEmspPercent,
      ]),
    });
  }

  private applyEmspResponseToView(response: any) {
    if (response?.address) {
      this.nstreet = response.address.street;
      this.nnumber = response.address.houseNumber;
      this.npostalcode = response.address.postalCode?.toString();
      this.ncity = response.address.city;
    }
    this.ncompany = response?.company ?? this.ncompany;
    this.npercent = response?.percent?.toString();
  }

  private resetEmspForm() {
    if (!this.emspForm || !this.userProfile) {
      return;
    }

    this.emspForm.reset({
      company: this.ncompany ?? this.userProfile.company ?? "",
      address: {
        street: this.nstreet ?? "",
        houseNumber: this.nnumber ?? "",
        postalCode: this.npostalcode ?? "",
        city: this.ncity ?? "",
      },
      sitepartnerPercent: this.formatPercentForInput(
        this.npercent ?? this.applicationFee?.percent?.toString()
      ),
    });
  }

  onEmspPercentInput() {
    const currentValue = this.emspForm.get("sitepartnerPercent").value;
    const formattedValue = this.formatPercentForInput(currentValue);
    if (currentValue !== formattedValue) {
      this.emspForm.get("sitepartnerPercent").setValue(formattedValue, {
        emitEvent: false,
      });
    }
    this.emspForm.get("sitepartnerPercent").updateValueAndValidity({
      emitEvent: false,
    });
  }

  private formatPercentForInput(percentValue: string): string {
    if (!percentValue) {
      return "";
    }

    let normalized = percentValue.replace(/\./g, ",");
    normalized = normalized.replace(/[^0-9,]/g, "");
    const firstCommaIndex = normalized.indexOf(",");
    if (firstCommaIndex >= 0) {
      const integerPart = normalized.slice(0, firstCommaIndex);
      const decimalPart = normalized
        .slice(firstCommaIndex + 1)
        .replace(/,/g, "")
        .slice(0, 1);
      normalized = `${integerPart},${decimalPart}`;
    }
    return normalized;
  }

  private parseEmspPercent(percentValue: string): number | null {
    if (!percentValue) {
      return null;
    }

    const normalized = percentValue.replace(",", ".");
    const parsed = Number(normalized);
    if (Number.isNaN(parsed)) {
      return null;
    }
    return parsed;
  }

  private validateEmspPercent = (
    control: AbstractControl
  ): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const value = this.formatPercentForInput(control.value);
    const normalized = value.replace(",", ".");
    const parsed = Number(normalized);
    if (Number.isNaN(parsed)) {
      return { invalidPercent: true };
    }

    if (parsed < 0 || parsed > 100) {
      return { outOfRange: true };
    }

    const precision = parsed * 10;
    if (precision !== Math.trunc(precision)) {
      return { tooManyDecimals: true };
    }

    return null;
  };

  createFormForCustomer() {
    var addressGroup = new UntypedFormGroup({
      id:
        this.userProfile.address != null
          ? new UntypedFormControl(this.userProfile.address?.id)
          : new UntypedFormControl(0),
      postalCode: new UntypedFormControl(this.userProfile.address?.postalCode, [
        Validators.required,
        Validators.pattern("^[0-9]*$"),
        Validators.maxLength(6),
        Validators.minLength(4),
      ]),
      //city: new UntypedFormControl(this.userProfile.address?.city, [Validators.required, Validators.pattern('^[\u00C0-\u017Fa-zA-Z]+(?:[\\s-][\u00C0-\u017Fa-zA-Z]+)*$')]),
      city: new UntypedFormControl(this.userProfile.address?.city, [
        Validators.required,
      ]),
      //street: new UntypedFormControl(this.userProfile.address?.street, [Validators.required, Validators.pattern('^[\u00C0-\u017Fa-zA-Z.]+(?:[\\s-][\u00C0-\u017Fa-zA-Z.]+)*$')]),
      street: new UntypedFormControl(this.userProfile.address?.street, [
        Validators.required,
      ]),
      houseNumber: new UntypedFormControl(
        this.userProfile.address?.houseNumber,
        [Validators.required, Validators.pattern("^[0-9]+[A-Za-z0-9\\s./-]*$")]
      ),
      country: new UntypedFormControl(
        this.userProfile.address?.country ?? "DE"
      ),
    });

    var settingsGroup = new UntypedFormGroup({
      id:
        this.userProfile.settings != null
          ? new UntypedFormControl(this.userProfile.settings?.id)
          : new UntypedFormControl(0),
      customDeliveryNotes:
        this.userProfile.settings?.customDeliveryNotes != null
          ? new UntypedFormControl(
              this.userProfile.settings?.customDeliveryNotes
            )
          : new UntypedFormControl(false),
      ownTransactionNotifications:
        this.userProfile.settings?.ownTransactionNotifications != null
          ? new UntypedFormControl(
              this.userProfile.settings?.ownTransactionNotifications
            )
          : new UntypedFormControl(false),
      userTransactionNotifications:
        this.userProfile.settings?.userTransactionNotifications != null
          ? new UntypedFormControl(
              this.userProfile.settings?.userTransactionNotifications
            )
          : new UntypedFormControl(false),
      acceptAd: new UntypedFormControl(this.userProfile.acceptAd),
    });

    this.formService.form = new UntypedFormGroup({
      firstName: new UntypedFormControl(this.userProfile.firstName, [
        Validators.required,
        Validators.maxLength(50),
      ]),
      lastName: new UntypedFormControl(this.userProfile.lastName, [
        Validators.required,
        Validators.maxLength(50),
      ]),
      gender: new UntypedFormControl(this.userProfile.gender, [
        Validators.required,
      ]),
      type: new UntypedFormControl(this.userProfile.type),
      company: new UntypedFormControl(this.userProfile.company),
      phone: new UntypedFormControl(this.userProfile.phoneNumber, [
        Validators.required,
        Validators.pattern(/^\+?[1-9]\d{0,3}[\s.-]?\(?\d{2,5}\)?([\s.-]?\d{2,10})+$/),
        Validators.minLength(6),
      ]),
      internalDescription: new UntypedFormControl(
        this.userProfile.internalDescription
      ),
      pictureUri: new UntypedFormControl(this.userProfile.pictureUri),
      pictureFileName: new UntypedFormControl(this.userProfile.pictureFileName),
      email: new UntypedFormControl(this.userProfile.email, [Validators.email]),

      address: addressGroup,
      settings: settingsGroup,
      subscriptionTypeId: new UntypedFormControl(
        this.userProfile.subscriptionTypeId
      ),
    });

    this.formService.formMap = new Map<string, UntypedFormGroup>();
    this.formService.formMap.set("address", addressGroup);
    this.formService.formMap.set("settings", settingsGroup);
  }

  createFormForUser() {
    var addressGroup = new UntypedFormGroup({
      id:
        this.userProfile.address != null
          ? new UntypedFormControl(this.userProfile.address?.id)
          : new UntypedFormControl(0),
      postalCode: new UntypedFormControl(this.userProfile.address?.postalCode, [
        Validators.required,
        Validators.pattern("^[0-9]*$"),
        Validators.maxLength(6),
        Validators.minLength(4),
      ]),
      city: new UntypedFormControl(this.userProfile.address?.city, [
        Validators.required,
      ]),
      street: new UntypedFormControl(this.userProfile.address?.street, [
        Validators.required,
      ]),
      houseNumber: new UntypedFormControl(
        this.userProfile.address?.houseNumber,
        [Validators.required, Validators.pattern("^[0-9]+[A-Za-z0-9\\s./-]*$")]
      ),
      country: new UntypedFormControl(
        this.userProfile.address?.country ?? "DE"
      ),
    });

    var settingsGroup = new UntypedFormGroup({
      id:
        this.userProfile.settings != null
          ? new UntypedFormControl(this.userProfile.settings?.id)
          : new UntypedFormControl(0),
      customDeliveryNotes:
        this.userProfile.settings?.customDeliveryNotes != null
          ? new UntypedFormControl(
              this.userProfile.settings?.customDeliveryNotes
            )
          : new UntypedFormControl(false),
      ownTransactionNotifications:
        this.userProfile.settings?.ownTransactionNotifications != null
          ? new UntypedFormControl(
              this.userProfile.settings?.ownTransactionNotifications
            )
          : new UntypedFormControl(false),
      userTransactionNotifications:
        this.userProfile.settings?.userTransactionNotifications != null
          ? new UntypedFormControl(
              this.userProfile.settings?.userTransactionNotifications
            )
          : new UntypedFormControl(false),
      acceptAd: new UntypedFormControl(this.userProfile.acceptAd),
    });

    this.formService.form = new UntypedFormGroup({
      firstName: new UntypedFormControl(this.userProfile.firstName, [
        Validators.required,
        Validators.maxLength(50),
      ]),
      lastName: new UntypedFormControl(this.userProfile.lastName, [
        Validators.required,
        Validators.maxLength(50),
      ]),
      gender: new UntypedFormControl(this.userProfile.gender, [
        Validators.required,
      ]),
      type: new UntypedFormControl(this.userProfile.type),
      company: new UntypedFormControl(this.userProfile.company),
      internalDescription: new UntypedFormControl(
        this.userProfile.internalDescription
      ),
      phone: new UntypedFormControl(this.userProfile.phoneNumber, [
        Validators.required,
          Validators.pattern(/^\+?[1-9]\d{0,3}[\s.-]?\(?\d{2,5}\)?([\s.-]?\d{2,10})+$/)
        ,
        Validators.minLength(6),
      ]),
      pictureUri: new UntypedFormControl(this.userProfile.pictureUri),
      pictureFileName: new UntypedFormControl(this.userProfile.pictureFileName),
      email: new UntypedFormControl(this.userProfile.email, [Validators.email]),

      //email: new UntypedFormControl(this.userProfile.email, [Validators.required, Validators.email]),
      address: addressGroup,
      settings: settingsGroup,
      subscriptionTypeId: new UntypedFormControl(
        this.userProfile.subscriptionTypeId
      ),
    });

    this.formService.formMap = new Map<string, UntypedFormGroup>();
    this.formService.formMap.set("address", addressGroup);
    this.formService.formMap.set("settings", settingsGroup);
  }

  public isTypeCompany() {
    if (!this.formService.form.get("company")) return false;
    if (!this.userProfile) return;
    if (this.userProfile.type == "company") {
      this.formService.form.get("company").setValidators([Validators.required]);
      this.formService.form.get("company").updateValueAndValidity();
      return true;
    }
    this.formService.form.get("company").clearValidators();
    this.formService.form.get("company").updateValueAndValidity();
    return false;
  }

  trimPhone() {
    const control = this.formService.form.get('phone');
    if (control?.value) {
      control.setValue(control.value.trim());
    }
  }

  async onSubmit(formValue) {
    const userProfile: UserProfile = {
      firstName: formValue.firstName,
      lastName: formValue.lastName,
      gender: formValue.gender,
      company: formValue.company,
      phoneNumber: formValue.phone,
      address: formValue.address,
      acceptAd: formValue.settings.acceptAd,
      settings: formValue.settings,
      pictureUri: formValue.pictureUri,
      pictureFileName: formValue.pictureFileName,
      internalDescription: formValue.internalDescription,
    };

    this.toastService.loading("Wird gespeichert...", true);
    try {
      if (this.isOperatorView && this.isTypeCompany() === true) {
        var customerId = this.activatedRoute.parent.snapshot.params.key;
        await this.usersService
          .patchUserProfileOfCustomer(customerId, userProfile)
          .toPromise();
      }

      if (this.isCustomerView && this.isTypeCompany() === true) {
        await this.usersService
          .patchUserProfileOfCurrentCustomer(userProfile)
          .toPromise();
      } else {
        await this.usersService
          .patchUserProfile(userProfile, this.userId)
          .toPromise();
      }
    } catch (error) {
      this.toastService.error(
        $localize`Beim Speichern der Änderungen ist ein Fehler aufgetreten.`,
        0,
        true
      );
      return;
    }

    this.ngOnInit();
    this.toastService.success(
      $localize`Änderungen wurden gespeichert`,
      0,
      true
    );
  }

  async onFileSelect(event) {
    var file: File = event.target.files.item(0);

    if (file) {
      var fileAllowed = false;

      if (
        file.type == "image/jpeg" ||
        file.type == "image/jpg" ||
        file.type == "image/png"
      ) {
        fileAllowed = true;
      } else {
        fileAllowed = false;
        this.showWrongFileTypeError();
      }

      if (file.size > 2000000) {
        fileAllowed = false;
        this.showWrongFileSizeError();
      }

      if (fileAllowed) {
        this.file = file;

        var fileExtension = this.file.name.split(".").pop();

        var blob = this.File;
        var newFile = new File([blob], this.userId + "." + fileExtension, {
          type: this.file.type,
        });

        var uploadResult = await this.uploadFile(newFile);

        const patch: PatchUserProfilePicture = {
          pictureUri: uploadResult[0].fileUri,
          pictureFileName: uploadResult[0].fileName,
        };

        if (this.isOperatorView) {
          var customerId = this.activatedRoute.parent.snapshot.params.key;

          this.usersService
            .patchProfilePictureOfCustomer(patch, customerId)
            .subscribe((result) => {
              this.loadProfile();
            });
        } else {
          this.usersService.patchProfilePicture(patch).subscribe((result) => {
            this.loadProfile();
          });
        }
      }
    }
  }

  async uploadFile(file: File): Promise<UploadResponse[]> {
    var formData = new FormData();
    formData.append("file", file);
    formData.append("path", "pictures/profile");

    var result = await this.filesService.uploadAsync(formData);

    return result;
  }

  removeProfilePicture() {
    const patch: PatchUserProfilePicture = {
      pictureUri: null,
      pictureFileName: null,
    };

    if (this.isOperatorView) {
      if (this.isUserProfile) {
        this.usersService
          .patchProfilePictureOfUser(patch, this.userId)
          .subscribe((result) => {
            this.loadProfile();
          });
      } else {
        var customerId = this.activatedRoute.parent.snapshot.params.key;

        this.usersService
          .patchProfilePictureOfCustomer(patch, customerId)
          .subscribe((result) => {
            this.loadProfile();
          });
      }
    } else {
      this.usersService.patchProfilePicture(patch).subscribe((result) => {
        this.loadProfile();
      });
    }
  }

  onSettingsChange(event) {
    var settings = this.formService.form.get("settings").value;

    if (this.isOperatorView) {
      var customerId = this.activatedRoute.parent.snapshot.params.key;

      this.usersService
        .updateMasterUserOfCustomerSettings(customerId, settings)
        .subscribe((result) => {});
    } else {
      this.usersService
        .updateCurrentUserSettings(settings)
        .subscribe((result) => {});
    }
  }

  openChangePasswordDialog() {
    const dialogRef = this.dialog.open(ChangePasswordDialogContentComponent, {
      centered: true,
      backdrop: "static",
    });

    dialogRef.result.then(
      (result) => {},
      (backdrop) => {}
    );
  }

  openChangePasswordForCustomerDialog() {
    const dialogRef = this.dialog.open(
      ChangePasswordDialogForCustomerContentComponent,
      { centered: true, backdrop: "static" }
    );
    dialogRef.componentInstance.customerId =
      this.activatedRoute.parent.snapshot.params.key;

    dialogRef.result.then(
      (result) => {},
      (backdrop) => {}
    );
  }

  confirmEmailForCustomer() {
    var customerId = this.activatedRoute.parent.snapshot.params.key;
    this.authenticationService.confirmEmailforCustomer(customerId).subscribe(
      (_) => {
        this.spinner.show();
        this.loadProfile();
        this.toastService.success(
          $localize`:@@EmailConfirmedSuccess:Die E-Mail-Adresse wurde erfolgreich bestätigt.`
        );
        this.spinner.hide();
      },
      (error) => {
        this.messageService.setError(error);
      }
    );
  }

  openDeleteProfileDialog() {
    const dialogRef = this.dialog.open(
      DeleteUserProfileDialogContentComponent,
      { centered: true, animation: false, backdrop: "static" }
    );

    dialogRef.result.then(
      (result) => {
        if (result.isSuccess) {
          this.authenticationService.logout();
          this.router.navigate(["/auth/login"]);
        }
      },
      (backdrop) => {}
    );
  }

  openDeleteUserForCustomerDialog() {
    const dialogRef = this.dialog.open(
      DeleteUserForCustomerDialogContentComponent,
      { centered: true, animation: false, backdrop: "static" }
    );
    dialogRef.componentInstance.customerId =
      this.activatedRoute.parent.snapshot.params.key;
    dialogRef.componentInstance.userId = this.userId;
    dialogRef.result.then(
      (result) => {
        console.log("result", result);

        if (result.success) {
          if (this.router.url.includes("/users/")) {
            this.router.navigate(["/users"]);
          } else if (this.router.url.includes("/customer/")) {
            this.router.navigate(["/customer"]);
          }
        }
      },
      (backdrop) => {}
    );
  }

  openInviteCustomerDialog() {
    const dialogRef = this.dialog.open(InviteCustomerDialogContentComponent, {
      centered: true,
      backdrop: "static",
    });
    dialogRef.componentInstance.customerId =
      this.activatedRoute.parent.snapshot.params.key;
    dialogRef.result.then(
      (result) => {},
      (backdrop) => {}
    );
  }

  showWrongFileTypeError() {
    Swal.fire({
      title: $localize`:@@ProfileWrongTypeTitel:Falsches Dateiformat`,
      text: $localize`:@@ProfileWrongTypeText:Die gewählte Datei hat das falsche Format. Erlaubt sind: jpg, jpeg, png.`,
      icon: "error",
      showConfirmButton: false,
      showDenyButton: true,
      denyButtonText: $localize`:@@ProfileWrongTypeConfirm:Zurück`,
      focusDeny: false,
    });
  }

  showWrongFileSizeError() {
    Swal.fire({
      title: $localize`:@@ProfileWrongSizeTitel:Falsche Dateigröße`,
      text: $localize`:@@ProfileWrongSizeText:Die gewählte Datei ist zu groß. Erlaubt sind Dateien bis zu 2 MB.`,
      icon: "error",
      confirmButtonText: $localize`:@@ProfileWrongSizeConfirm:Zurück`,
    });
  }

  openSuccessDialog() {
    Swal.fire({
      title: $localize`:@@ChangeDialogSaveSuccessHeader:Einstellungen wurden gespeichert!`,
      icon: "success",
      confirmButtonText: $localize`:@@DialogOkButton:OK`,
      confirmButtonColor: "green",
    }).then((result) => {
      this.ngOnInit();
    });
  }

  openCancelSuccessDialog() {
    Swal.fire({
      title: $localize`:@@CancelSubscriptionSuccessHeader:Abo wurde erfolgreich gekündigt!`,
      icon: "success",
      confirmButtonText: $localize`:@@DialogOkButton:OK`,
      confirmButtonColor: "green",
    }).then((result) => {
      this.ngOnInit();
    });
  }

  mapType() {
    switch (this.userProfile.type) {
      case "private":
        return "Privat";
      case "company":
        return "Geschäftlich";
    }
  }

  mapSubscriptionType() {
    switch (this.userProfile.subscriptionTypeId) {
      case 1:
        return "Basic";
      case 2:
        return "Standard";
      case 3:
        return "Premium";
      case 4:
        return "Enterprise";
    }
  }

  public async loadPricing() {
    if (this.currentUser && this.currentUser.pricingId) {
      this.pricingsService.getPricing(this.currentUser.pricingId).subscribe(
        (pricing) => {
          this.pricing = plainToClass(PricingDto, pricing);
          this.isLoading = false;
        },
        (error) => {}
      );
    } else {
      this.isLoading = false;
    }
  }

  showConfirmRemovePaymentMethodDialog() {
    Swal.fire({
      title: "Entfernen der Zahlungsmethode",
      text: "Alle aktuellen Ladevorgänge werden sofort abgerechnet und Sie verlieren den Zugang zum Ladepark.",
      icon: "question",
      confirmButtonText: "Bestätigen",
      confirmButtonColor: "#dc3545",
      showCancelButton: true,
      cancelButtonText: "Abbrechen",
      // cancelButtonColor: 'gray'
    }).then((result) => {
      if (result.isConfirmed) {
        this.removePaymentMethod();
      }
    });
  }
  public async removePaymentMethod() {
    if (this.stripeInfo.stripePaymentMethodId) {
      this.toastService.loading(
        $localize`:@@RemovingPaymentMethodToast:Zahlungsmethode wird entfernt.`
      );
      this.paymentsService.cancelSubscription(this.stripeInfo.userId).subscribe(
        (result) => {
          this.toastService.clear();
          if (result.isSuccess) {
            this.toastService.success(
              `Zahlungsmethode erfolgreich entfernt.`,
              0,
              true
            );
            this.ngAfterViewInit();
          } else {
            this.toastService.error(result.errors, 0, true);
          }
        },
        (error) => {
          this.toastService.clear();
          this.toastService.error(
            `Zahlungsmethode konnte nicht entfernt werden.`,
            0,
            true
          );
        }
      );
    } else {
      console.warn(`User is missing payment method id.`);
    }
  }

  public parsePrice(price) {
    return price.toLocaleString("de-DE", {
      style: "currency",
      currency: "EUR",
    });
  }

  public parseAmount(amount) {
    return parseFloat(Math.abs(amount / 100).toFixed(2)).toLocaleString();
  }

  public parseDate(date) {
    return new Date(date).toISOString().split("T")[0];
  }

  getNextInvoiceValue() {
    if (this.transactions.length > 0) {
      return parseFloat(
        (
          (this.transactions
            .map((t) => t.meterAmount)
            .reduce((pv, cv) => pv + cv) /
            1000) *
          this.pricing.price
        ).toFixed(2)
      ).toLocaleString();
    }
    return 0;
  }

  openChangeEmailAdrDialog() {
    const emailDialogRef = this.dialog.open(EditEmailDialogContentComponent, {
      centered: true,
      backdrop: "static",
    });
    emailDialogRef.componentInstance.userId = this.userProfile.id;

    emailDialogRef.closed.subscribe(
      (emailDialogResult) => {
        if (emailDialogResult.status != "ok") return;

        if (this.isOperatorView) {
          const requestDto: UpdateUserEmailRequest = {
            userGuid: this.userProfile.id,
            newEmail: emailDialogResult.email,
          };

          this.toastService.clear();
          this.toastService.loading(
            $localize`:@@SavingChanges:Änderungen werden übernommen...`,
            true
          );
          this.usersService.updateUserEmailByUserId(requestDto).subscribe(
            (response) => {
              this.toastService.clear();
              window.location.reload();
            },
            (error) => {
              this.toastService.clear();
              this.toastService.error(
                $localize`:@@UnexpectedErrorChangeEmail:Unerwarteter Fehler beim Ändern der E-Mail-Adresse.`,
                4500,
                true
              );
            }
          );
          return;
        }

        const confirmationCodeDto: ConfirmationCodeDto =
          new ConfirmationCodeDto();
        confirmationCodeDto.userId = this.userProfile.id;
        confirmationCodeDto.email = emailDialogResult.email;

        this.spinner.show();
        this.toastService.clear();
        this.toastService.loading("Bitte warten...", true);
        this.usersService.sendConfirmationCode(confirmationCodeDto).subscribe(
          (sendConfirmationCodeResponse) => {
            this.toastService.clear();
            this.spinner.hide();

            if (sendConfirmationCodeResponse.statusCode != "OK") {
              this.toastService.error(
                `Fehler beim Senden des Bestätigungscodes`,
                4500,
                true
              );
              return;
            }

            this.openConfirmationCodeDialog(
              confirmationCodeDto,
              sendConfirmationCodeResponse
            );
          },
          (error) => {
            this.toastService.clear();
            this.toastService.error(
              $localize`:@@SorryUnknownError:Es tut uns leid, es ist ein unbekannter Fehler aufgetreten`,
              4500,
              true
            );
            this.spinner.hide();
          }
        );
      },
      (error) => {
        this.toastService.error(
          $localize`:@@SorryUnknownError:Es tut uns leid, es ist ein unbekannter Fehler aufgetreten`,
          4500,
          true
        );
      }
    );
  }
  openConfirmationCodeDialog(
    confirmationCodeDto: ConfirmationCodeDto,
    sendConfirmationCodeResponse: any
  ) {
    //[Frontend] Enter Confirmation-Code, received by new E-Mail-Adr.
    const confirmationCodeDialogRef = this.dialog.open(
      EnterConfirmationCodeDialogContentComponent,
      { centered: true, backdrop: "static" }
    );
    confirmationCodeDialogRef.componentInstance.confirmationCode =
      confirmationCodeDto;

    confirmationCodeDialogRef.closed.subscribe(
      (EnterCodeDialogResult) => {
        if (EnterCodeDialogResult.status != "ok") return;

        confirmationCodeDto.code = EnterCodeDialogResult.code;
        this.changeVerifyEmailByUserId(
          confirmationCodeDto,
          EnterCodeDialogResult
        );
      },
      (error) => {
        this.toastService.error(
          `Es tut uns leid, es ist ein unbekannter Fehler aufgetreten`,
          4500,
          true
        );
      }
    );
  }
  changeVerifyEmailByUserId(
    confirmationCodeDto: ConfirmationCodeDto,
    sendCodeDialogResult: any
  ) {
    this.usersService
      .changeVerifiedEmailByUserId(confirmationCodeDto)
      .subscribe(
        (changeEmailResponse) => {
          if (changeEmailResponse.statusCode != "200") return;

          window.location.reload();
        },
        (error) => {
          this.toastService.error(
            $localize`:@@SorryUnknownError:Es tut uns leid, es ist ein unbekannter Fehler aufgetreten`,
            4500,
            true
          );
        }
      );
  }
}
